(function() {
  var GeoJSONLayer,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  GeoJSONLayer = App.loadClass('grower::handlers/data/GeoJSON_Layer');

  exports.Layer_Planting_Rx_Visualize = (function(superClass) {
    extend(Layer_Planting_Rx_Visualize, superClass);

    function Layer_Planting_Rx_Visualize() {
      Layer_Planting_Rx_Visualize.__super__.constructor.call(this);
      this.useSlider = false;
      this.fetchUrl = 'backend/grower/layers/planting-rx/visualize';
    }

    Layer_Planting_Rx_Visualize.prototype.initSlider = function() {
      var ref;
      return this.slider = (ref = this.sidebar_row) != null ? ref.find('.shapefile-slider') : void 0;
    };

    Layer_Planting_Rx_Visualize.prototype.makeInfoWindow = function(ft, layer) {
      var props;
      props = {
        'ID': ft.properties.display_id,
        'Hybrid': ft.properties.hybrid_name,
        'Acres': ft.properties.acres,
        'Population': ft.properties.population
      };
      if (ft.properties.truth_strip) {
        props['Truth Strip'] = '';
      }
      ft.properties = props;
      return Layer_Planting_Rx_Visualize.__super__.makeInfoWindow.call(this, ft, layer);
    };

    return Layer_Planting_Rx_Visualize;

  })(GeoJSONLayer);

}).call(this);
